import React from 'react'
import PropTypes from 'prop-types'
import EditPageIcon from './../icons/EditPageIcon'
import './../../ui.style.scss'

const EditPageButton = ({ isDisabled, onClick, ...props }) => (
  <div className={`add-button-page ${isDisabled ? 'disabled' : ''}`} onClick={isDisabled ? () => {} : onClick}>
    <EditPageIcon />
  </div>
)

EditPageButton.propTypes = {
  /** disabled status of Button. */
  isDisabled: PropTypes.bool,
  /** Button click action. */
  onClick: PropTypes.func.isRequired
}

EditPageButton.defaultProps = {
  isDisabled: false
}

export default EditPageButton
